import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";

import FormContainer from "../../../../../../common/components/form_container";
import { CargoHabilidade } from "../../../../domain/models/cargo_habilidade";
import { useMemo } from "react";
import { GenerateCargoHabilidadeColumnsDefinition } from "../columns";
import { TablePagination } from "@mui/material";
import { GridRowSelectionModel } from "@mui/x-data-grid-pro";

/**
 * TabHabilidades
 */

type Props = {
  loading: boolean,
  saving: boolean,
  gridRowSelectionModel: GridRowSelectionModel,
  cargoHabilidades: CargoHabilidade[],
  page: number,
  rowsPerPage: number,
  totalItems: number,
  onPageChange: (page: number) => void,
  onRowsPerPageChange: (rowsPerPage: number) => void,
  onSelectionModelChange: (selectionModel: GridRowSelectionModel) => void,
};

export const TabHabilidades = ({
  loading,
  gridRowSelectionModel,
  cargoHabilidades,
  page,
  rowsPerPage,
  totalItems,
  onPageChange,
  onRowsPerPageChange,
  onSelectionModelChange,
}: Props) => {
  const columnsDef = useMemo(() => {
    return GenerateCargoHabilidadeColumnsDefinition();
  }, []);

  return (
    <>
      <div className='w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4'>
        <FormContainer title='Selecione as Habilidades' arrangement='fullRow' border={false}>
          <>
            <StyledDataGrid
              tableName="tab_habilidades"
              getRowHeight={() => 'auto'}
              disableColumnMenu={false}
              getRowId={(row: CargoHabilidade) => row.idHabilidade}
              columns={columnsDef}
              loading={loading}
              checkboxSelection={true}
              rowSelectionModel={gridRowSelectionModel}
              onRowSelectionModelChange={onSelectionModelChange}
              rows={cargoHabilidades}
              rowCount={cargoHabilidades.length}
              pageSizeOptions={[100]}
              paginationMode="server"
              paginationModel={{
                page: page,
                pageSize: rowsPerPage,
              }} />

            <TablePagination
              component="div"
              count={totalItems}
              page={page - 1}
              rowsPerPageOptions={[100]}
              onPageChange={(_, p) => onPageChange(p)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value))} />

          </>
        </FormContainer>
      </div>
    </>
  );
}